import { toast } from 'react-toastify';
import React, { useState, useEffect } from "react";
import API from "../../Network/API";
import { Link } from "react-router-dom";
import AddMeetingSchedule from "../Modal/AddMeetingSchedule";
import MeetingShare from "../Modal/MeetingShare";
import ContentLoader from "react-content-loader"
import ShareMeeting from '../Modal/ShareMeeting';
import { useSelector, useDispatch } from 'react-redux';
import EditMeeting from '../Modal/EditMeeting';
import { useTranslation } from "react-i18next";
import { UPCOMING_MEETING_FETCH_SUCCESS, UPCOMING_MEETING_FETCH_START, UPCOMING_MEETING_FETCH_ERROR, MEETING_INVITE_RECEIVED } from '../../Reducer/UpcomingMeetingReducer';
import MeetingCard from './MeetingCard';

toast.configure();
export default function Meeting() {
    const { t } = useTranslation()
    const dispatch = useDispatch();
    const [meetingId, setMeetingId] = useState('');
    const [loading, setLoading] = useState(false);
    const [modalDialog, setModalDialog] = useState(false);
    const [addModalDialog, setAddModalDialog] = useState(false);
    const [sendToShareData, setSendToShareData] = useState(null);

    const [isMeetingLoading, setMeetingLoading] = useState(false);
    const [demo_data, setDatas] = useState([{ id: 1 }, { id: 2 }, { id: 3 }, { id: 4 }, { id: 5 }, { id: 6 }, { id: 7 }, { id: 8 }, { id: 9 }, { id: 10 }]);
    const [progress, setProgress] = useState(false);
    const [isFetching, setIsFetching] = useState(false);
    const [page, setPage] = useState(1);
    const [next_page, setNextPage] = useState('/v1/upcoming_meeting_all');
    const [nextPageUrl, setNextPageURL] = useState(null);
    const [lengthData, setDataLength] = useState(0);
    const myArr = JSON.parse(localStorage.getItem('user_data'));
    const [modalDialogShare, setModalDialogShare] = useState(false);
    const [sc_meet, setScMeet] = useState(null);
    const [edit_modalDialog, setEditModalDialog] = useState(false);
    const usert_timez = useSelector((state) => state.timeZoneReducer);

    // ── Single source of truth: Redux (updated by Soketi in real-time) ────────
    const meetingList    = useSelector((state) => state.upcomingMeetingReducer.data);
    const needsRefresh   = useSelector((state) => state.upcomingMeetingReducer.needsRefresh);

    // Auto-refetch when an invite arrives via Soketi
    useEffect(() => {
        if (needsRefresh) {
            fetchRepositories();
            dispatch(MEETING_INVITE_RECEIVED()); // reset the flag (needsRefresh → false is implicit on next fetch overwrite)
        }
    }, [needsRefresh]); // eslint-disable-line react-hooks/exhaustive-deps

    const toggleModalSahre = (meeting_room) => {
        setScMeet(meeting_room)
        setModalDialogShare(!modalDialogShare)
    };

    const toggleEditMeeting = (meeting_room) => {
        setScMeet(meeting_room)
        setEditModalDialog(!modalDialog)
    };

    useEffect(() => {
        fetchRepositories()
    }, []);

    function fetchRepositories() {
        setProgress(true);
        dispatch(UPCOMING_MEETING_FETCH_START());

        API.get(next_page, {
            'offset': meetingList.length
        }).then((response) => {
            const paginator = response.data.data;
            // Push into Redux — both Meeting.js AND HomeMeeting.js stay in sync
            dispatch(UPCOMING_MEETING_FETCH_SUCCESS(paginator.meeting_data));
            setProgress(false);
            setNextPageURL(paginator.next_page_url);
            setPage((page + 1));
        }).catch(() => {
            dispatch(UPCOMING_MEETING_FETCH_ERROR());
            setProgress(false);
        });
    }

    const toggleModal = () => {
        setModalDialog(!modalDialog)
    };

    const toggleModal1 = () => {
        setAddModalDialog(!addModalDialog)
    };

    const _new_meeting = () => {
        setLoading(true);
        API.post('/v1/meetings/instant', {
            meeting_title: '',
            timezone: usert_timez?.timezone || 'UTC',
        }).then(res => {
            const data = res.data;
            // Cache token so MeetingRoom.js can skip the join API call
            sessionStorage.setItem(
                `livekit_meeting_${data.room_name}`,
                JSON.stringify({
                    token:                   data.token,
                    livekit_url:             data.livekit_url,
                    room_title:              data.room_title,
                    is_waiting_room_enabled: data.is_waiting_room_enabled || false,
                    host_identity:           data.host_identity || String(myArr?.id || ''),
                })
            );
            setLoading(false);
            // Navigate directly into the meeting room (pre-join screen)
            window.location.href = '/meeting/' + data.room_name;
        }).catch(() => {
            setLoading(false);
            toast.error('Failed to create meeting. Please try again.');
        });
    }

    const _start_meeting = (meeting_id) => {
        if (meeting_id) {
            window.location.href = '/meeting/' + meeting_id;
        } else {
            toast.error('Please enter a meeting ID');
        }
    }


    function scheduleStart(meeting_id) {
        window.location.href = "/meeting/" + meeting_id;
    }

    // ── No 30s poll needed — Soketi pushes MeetingStatusChanged in real-time ─
    // Kept as a 120s fallback safety net only (high-latency/offline recovery)
    useEffect(() => {
        const id = setInterval(() => fetchRepositories(), 120000);
        return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    // const meeting_delete = (m_id) => {
    //     var result = window.confirm("Are you sure want to delete?");
    //     if (result == true) {
    //       setLoading(true)
    //       API.delete("/meeting_delete/" + m_id).then((response) => {
    //         setLoading(false)
    //         if (response.data.success === true) {
    //           toast.success('delete successfully');
    //         }
    //       });
    //     }

    //   }
    return (
        <>
            <div className="min-vh-100 bg-white">
                <div className="container py-4">
                    <div className="row justify-content-center">
                        <div className="col-lg-8 col-xl-7">
                            <div className="d-flex align-items-center justify-content-between mb-4">
                                <div>
                                    <h2 className="fw-bold text-dark mb-1">Connects Meeting</h2>
                                    <p className="text-muted mb-0">Start instant meetings or schedule for later</p>
                                </div>
                                <Link
                                    to="/meeting-history"
                                    className="btn btn-outline-dark rounded-pill px-3 py-2 d-flex align-items-center"
                                    style={{ fontSize: '13px', fontWeight: '500', whiteSpace: 'nowrap' }}
                                >
                                    <i className="fa-solid fa-clock-rotate-left me-2" style={{ fontSize: '11px' }}></i>
                                    {t('History')}
                                </Link>
                            </div>
                            
                            <div className="meeting-main-section position-relative" style={{ zIndex: 10 }}>
                                <div className="mb-3">

                                    <div className="row g-2 mb-3">
                                        <div className="col-md-6">
                                            <div className="dropdown w-100">
                                                <button
                                                    type="button"
                                                    className="btn btn-dark w-100 py-2 px-3 rounded-2 dropdown-toggle d-flex align-items-center justify-content-center"
                                                    aria-expanded="false"
                                                    data-bs-toggle="dropdown"
                                                    id="dropdownMenuLink"
                                                    style={{ fontSize: '14px', fontWeight: '500' }}
                                                >
                                                    <i className="fa-solid fa-video me-2" style={{ fontSize: '12px' }}></i>
                                                    {t('New Meeting')}
                                                </button>
                                                <div className="dropdown-menu border-0 shadow rounded-2 mt-1" style={{ zIndex: 1055, backgroundColor: '#fff', minWidth: '320px' }}>
                                                    <div className="p-2">
                                                        <a
                                                            onClick={() => _new_meeting()}
                                                            className="dropdown-item py-2 px-2 rounded-2 d-flex align-items-center hover-bg-light"
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s ease', whiteSpace: 'normal' }}
                                                        >
                                                            <div className="me-2 flex-shrink-0">
                                                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                                    <i className="fa-solid fa-play text-dark" style={{ fontSize: '11px' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 min-w-0">
                                                                <div className="fw-medium text-dark" style={{ fontSize: '15px' }}>{t('Start an instant meeting')}</div>
                                                                <div className="text-muted" style={{ fontSize: '12px' }}>Begin meeting right now</div>
                                                            </div>
                                                        </a>
                                                        <a
                                                            className="dropdown-item py-2 px-2 rounded-2 d-flex align-items-center hover-bg-light"
                                                            onClick={() => toggleModal1()}
                                                            style={{ cursor: 'pointer', transition: 'all 0.2s ease', whiteSpace: 'normal' }}
                                                        >
                                                            <div className="me-2 flex-shrink-0">
                                                                <div className="bg-light rounded-circle d-flex align-items-center justify-content-center" style={{ width: '32px', height: '32px' }}>
                                                                    <i className="fa-solid fa-calendar-plus text-dark" style={{ fontSize: '11px' }}></i>
                                                                </div>
                                                            </div>
                                                            <div className="flex-grow-1 min-w-0">
                                                                <div className="fw-medium text-dark" style={{ fontSize: '15px' }}>{t('Create a meeting for later')}</div>
                                                                <div className="text-muted" style={{ fontSize: '12px' }}>Schedule and share meeting</div>
                                                            </div>
                                                        </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="d-flex gap-1">
                                                <input
                                                    type="text"
                                                    className="form-control py-2 px-3 rounded-2 flex-grow-1"
                                                    placeholder="Enter Meeting ID"
                                                    spellCheck="false"
                                                    value={meetingId}
                                                    onChange={(e) => setMeetingId(e.target.value)}
                                                    style={{ fontSize: '14px' }}
                                                />
                                                <button
                                                    type="button"
                                                    onClick={() => _start_meeting(meetingId)}
                                                    className={`btn ${meetingId === "" ? 'btn-outline-secondary' : 'btn-outline-dark'} px-3 rounded-2`}
                                                    disabled={meetingId === ""}
                                                    style={{ fontSize: '14px', fontWeight: '500', minWidth: '80px' }}
                                                >
                                                    <i className="fa-solid fa-arrow-right-to-bracket me-1" style={{ fontSize: '12px' }}></i>
                                                    {t('Join')}
                                                </button>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>

                            {meetingList.length > 0 && (
                                <div className="mt-4">
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <h4 className="fw-bold text-dark mb-0">{t('Upcoming Meetings')}</h4>
                                    </div>
                            {progress && demo_data?.map((post, i) => (
                                <div key={i} className="mb-2">
                                    <ContentLoader
                                        speed={2}
                                        width="100%"
                                        height={80}
                                        viewBox="0 0 100 80"
                                        backgroundColor="#f3f3f3"
                                        foregroundColor="#ecebeb"
                                        className="rounded-2"
                                    >
                                        <rect x="8" y="15" rx="6" ry="6" width="10" height="10" />
                                        <rect x="22" y="12" rx="3" ry="3" width="30" height="5" />
                                        <rect x="22" y="20" rx="2" ry="2" width="40" height="3" />
                                        <rect x="8" y="35" rx="3" ry="3" width="20" height="3" />
                                        <circle cx="12" cy="50" r="3" />
                                        <circle cx="20" cy="50" r="3" />
                                        <circle cx="28" cy="50" r="3" />
                                        <rect x="75" y="35" rx="3" ry="3" width="12" height="6" />
                                    </ContentLoader>
                                </div>
                            ))}
                            <div className="row row-cols-1 row-cols-lg-2 g-4 pb-4">
                                {!progress && meetingList?.map((value, index) => (
                                    <MeetingCard 
                                        key={index}
                                        meeting={value}
                                        currentUserId={myArr?.id}
                                        onStart={scheduleStart}
                                        onPreview={(id) => window.location.href = `/meeting-waiting/${id}`}
                                        onShare={toggleModalSahre}
                                        onEdit={toggleEditMeeting}
                                    />
                                ))}
                            </div>


                                </div>
                            )}

                            {meetingList.length === 0 && !progress && (
                                <div className="text-center py-5 mt-5">
                                    <div className="mb-3">
                                        <i className="fa-solid fa-calendar-xmark text-muted" style={{ fontSize: '36px' }}></i>
                                    </div>
                                    <h5 className="fw-bold text-dark mb-2">No upcoming meetings</h5>
                                    <p className="text-muted mb-3" style={{ fontSize: '14px' }}>Start an instant meeting or schedule one for later</p>
                                    <button
                                        onClick={() => toggleModal1()}
                                        className="btn btn-dark rounded-pill px-3 py-2"
                                        style={{ fontSize: '13px', fontWeight: '500' }}
                                    >
                                        <i className="fa-solid fa-calendar-plus me-2" style={{ fontSize: '11px' }}></i>
                                        Schedule Meeting
                                    </button>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <AddMeetingSchedule isModalVisible={addModalDialog} handleShowB={() => setAddModalDialog(false)} />
            <MeetingShare modalVisible={modalDialog} handleShow={() => setModalDialog(false)} shareData={sendToShareData} type={1} />
            <ShareMeeting isModalVisible={modalDialogShare} meetingRoom={sc_meet} handleShowB={() => setModalDialogShare(false)} />
            <EditMeeting isModalVisible={edit_modalDialog} meetingRoom={sc_meet} handleShowB={() => setEditModalDialog(false)} />
        </>
    )
}